import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const API_PREFIX = `${BASE_URL}/queries`;

export const listSavedQueries = (limit = 500) =>
  axios.get(`${API_PREFIX}/saved`, {
    params: { limit },
    headers: getAuthHeaders(),
  });

export const runSelectQuery = (query, limit = 1000) =>
  axios.post(
    `${API_PREFIX}/run`,
    { query, limit },
    { headers: getAuthHeaders() }
  );
